import type { default as TombstoneReasonType } from '../store/schema/TombstoneReasonType';
import { action } from 'satcheljs';

/**
 * Add each instanceKey in the given list to the tombstone map
 * @param instanceKeys - the instanceKeys to be added to the tombstones map
 * @param folderId for these instanceKeys
 * @param tombstoneReasonType - the reason for which the row is being tombstoned
 */
const addToTombstone = action(
    'addToTombstone',
    (instanceKeys: string[], folderId: string, tombstoneReasonType: TombstoneReasonType) => ({
        instanceKeys,
        folderId,
        tombstoneReasonType,
    })
);

export default addToTombstone;
